import { EMPTY_STRING, TABLE_COLUMNS } from "../../../constants";

const getActionColumnOfAgGridReact = (
  actionCellRenderer,
  headerName = EMPTY_STRING
) => {
  return {
    field: TABLE_COLUMNS.ACTION_ID,
    headerName: headerName,
    // all action column special properties (to simulate column resizing like dev tools network tab) are applied in ServerPaginationTable -> getFormattedColDefs to make sure it works for all type of last columns not just action last columns
    cellRenderer: actionCellRenderer,
  };
};

const getActionColumnOfReactDataTableComponent = (
  actionCellRenderer,
  isExpandableReactDataTableComponent = false
) => {
  let actionColumnObject = {
    id: TABLE_COLUMNS.ACTION_ID,
    name: TABLE_COLUMNS.ACTION_NAME,
    // all action column special properties (to simulate column resizing like dev tools network tab) are applied in useResizableTableColumns -> getReactDataTableFormattedColumns to make sure it works for all type of last columns not just action last columns
    // wrap the action cell into div to make sure content is right align (like column is pinned to right)
    cell: (row) => {
      return (
        <div className="ms-auto w-auto d-flex">{actionCellRenderer(row)}</div>
      );
    },
  };
  if (isExpandableReactDataTableComponent) {
    actionColumnObject = {
      ...actionColumnObject,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    };
  }

  return actionColumnObject;
};

export {
  getActionColumnOfAgGridReact,
  getActionColumnOfReactDataTableComponent,
};
